// NOM-035 — Baremos de calificación (Tablas 2–7)
// Niveles de riesgo por calificación final, categoría y dominio

export const COLORES_NIVEL = {
  "Nulo": "#10b981",
  "Bajo": "#22c55e",
  "Medio": "#f59e0b",
  "Alto": "#f97316",
  "Muy alto": "#ef4444",
};

export const NIVELES_ORDEN = ["Nulo", "Bajo", "Medio", "Alto", "Muy alto"];

// ── Guía II (Tabla 4) ──────────────────────────────────────────

export const NIVELES_RIESGO_GII = [
  { min: 0, max: 19, nivel: "Nulo", color: "#10b981", desc: "El riesgo resulta despreciable por lo que no se requiere medidas adicionales." },
  { min: 20, max: 44, nivel: "Bajo", color: "#22c55e", desc: "Es necesario una mayor difusión de la política de prevención de riesgos psicosociales y programas para: la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral." },
  { min: 45, max: 69, nivel: "Medio", color: "#f59e0b", desc: "Se requiere revisar la política de prevención de riesgos psicosociales y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, así como reforzar su aplicación y difusión, mediante un Programa de intervención." },
  { min: 70, max: 89, nivel: "Alto", color: "#f97316", desc: "Se requiere realizar un análisis de cada categoría y dominio, de manera que se puedan determinar las acciones de intervención apropiadas a través de un Programa de intervención." },
  { min: 90, max: 999, nivel: "Muy alto", color: "#ef4444", desc: "Se requiere realizar el análisis de cada categoría y dominio para establecer las acciones de intervención apropiadas, mediante un Programa de intervención que deberá incluir evaluaciones específicas." },
];

export const NIVELES_CATEGORIA_GII = {
  "Ambiente de trabajo": [
    { min: 0, max: 2, nivel: "Nulo" }, { min: 3, max: 4, nivel: "Bajo" },
    { min: 5, max: 6, nivel: "Medio" }, { min: 7, max: 8, nivel: "Alto" }, { min: 9, max: 999, nivel: "Muy alto" }
  ],
  "Factores propios de la actividad": [
    { min: 0, max: 9, nivel: "Nulo" }, { min: 10, max: 19, nivel: "Bajo" },
    { min: 20, max: 29, nivel: "Medio" }, { min: 30, max: 39, nivel: "Alto" }, { min: 40, max: 999, nivel: "Muy alto" }
  ],
  "Organización del tiempo de trabajo": [
    { min: 0, max: 3, nivel: "Nulo" }, { min: 4, max: 5, nivel: "Bajo" },
    { min: 6, max: 8, nivel: "Medio" }, { min: 9, max: 11, nivel: "Alto" }, { min: 12, max: 999, nivel: "Muy alto" }
  ],
  "Liderazgo y relaciones en el trabajo": [
    { min: 0, max: 9, nivel: "Nulo" }, { min: 10, max: 17, nivel: "Bajo" },
    { min: 18, max: 27, nivel: "Medio" }, { min: 28, max: 37, nivel: "Alto" }, { min: 38, max: 999, nivel: "Muy alto" }
  ],
};

export const NIVELES_DOMINIO_GII = {
  "Condiciones en el ambiente de trabajo": [
    { min: 0, max: 2, nivel: "Nulo" }, { min: 3, max: 4, nivel: "Bajo" },
    { min: 5, max: 6, nivel: "Medio" }, { min: 7, max: 8, nivel: "Alto" }, { min: 9, max: 999, nivel: "Muy alto" }
  ],
  "Carga de trabajo": [
    { min: 0, max: 11, nivel: "Nulo" }, { min: 12, max: 15, nivel: "Bajo" },
    { min: 16, max: 19, nivel: "Medio" }, { min: 20, max: 23, nivel: "Alto" }, { min: 24, max: 999, nivel: "Muy alto" }
  ],
  "Falta de control sobre el trabajo": [
    { min: 0, max: 4, nivel: "Nulo" }, { min: 5, max: 7, nivel: "Bajo" },
    { min: 8, max: 10, nivel: "Medio" }, { min: 11, max: 13, nivel: "Alto" }, { min: 14, max: 999, nivel: "Muy alto" }
  ],
  "Jornada de trabajo": [
    { min: 0, max: 0, nivel: "Nulo" }, { min: 1, max: 1, nivel: "Bajo" },
    { min: 2, max: 3, nivel: "Medio" }, { min: 4, max: 5, nivel: "Alto" }, { min: 6, max: 999, nivel: "Muy alto" }
  ],
  "Interferencia en la relación trabajo-familia": [
    { min: 0, max: 0, nivel: "Nulo" }, { min: 1, max: 1, nivel: "Bajo" },
    { min: 2, max: 3, nivel: "Medio" }, { min: 4, max: 5, nivel: "Alto" }, { min: 6, max: 999, nivel: "Muy alto" }
  ],
  "Liderazgo": [
    { min: 0, max: 2, nivel: "Nulo" }, { min: 3, max: 4, nivel: "Bajo" },
    { min: 5, max: 7, nivel: "Medio" }, { min: 8, max: 10, nivel: "Alto" }, { min: 11, max: 999, nivel: "Muy alto" }
  ],
  "Relaciones en el trabajo": [
    { min: 0, max: 4, nivel: "Nulo" }, { min: 5, max: 7, nivel: "Bajo" },
    { min: 8, max: 10, nivel: "Medio" }, { min: 11, max: 13, nivel: "Alto" }, { min: 14, max: 999, nivel: "Muy alto" }
  ],
  "Violencia": [
    { min: 0, max: 6, nivel: "Nulo" }, { min: 7, max: 9, nivel: "Bajo" },
    { min: 10, max: 12, nivel: "Medio" }, { min: 13, max: 15, nivel: "Alto" }, { min: 16, max: 999, nivel: "Muy alto" }
  ],
};

// ── Guía III (Tabla 7) ─────────────────────────────────────────

export const NIVELES_RIESGO_GIII = [
  { min: 0, max: 49, nivel: "Nulo", color: "#10b981", desc: "El riesgo resulta despreciable por lo que no se requiere medidas adicionales." },
  { min: 50, max: 74, nivel: "Bajo", color: "#22c55e", desc: "Es necesario una mayor difusión de la política de prevención de riesgos psicosociales y programas para: la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral." },
  { min: 75, max: 98, nivel: "Medio", color: "#f59e0b", desc: "Se requiere revisar la política de prevención de riesgos psicosociales y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, así como reforzar su aplicación y difusión, mediante un Programa de intervención." },
  { min: 99, max: 139, nivel: "Alto", color: "#f97316", desc: "Se requiere realizar un análisis de cada categoría y dominio, de manera que se puedan determinar las acciones de intervención apropiadas a través de un Programa de intervención." },
  { min: 140, max: 999, nivel: "Muy alto", color: "#ef4444", desc: "Se requiere realizar el análisis de cada categoría y dominio para establecer las acciones de intervención apropiadas, mediante un Programa de intervención que deberá incluir evaluaciones específicas." },
];

export const NIVELES_CATEGORIA_GIII = {
  "Ambiente de trabajo": [
    { min: 0, max: 4, nivel: "Nulo" }, { min: 5, max: 8, nivel: "Bajo" },
    { min: 9, max: 10, nivel: "Medio" }, { min: 11, max: 13, nivel: "Alto" }, { min: 14, max: 999, nivel: "Muy alto" }
  ],
  "Factores propios de la actividad": [
    { min: 0, max: 14, nivel: "Nulo" }, { min: 15, max: 29, nivel: "Bajo" },
    { min: 30, max: 44, nivel: "Medio" }, { min: 45, max: 59, nivel: "Alto" }, { min: 60, max: 999, nivel: "Muy alto" }
  ],
  "Organización del tiempo de trabajo": [
    { min: 0, max: 4, nivel: "Nulo" }, { min: 5, max: 6, nivel: "Bajo" },
    { min: 7, max: 9, nivel: "Medio" }, { min: 10, max: 12, nivel: "Alto" }, { min: 13, max: 999, nivel: "Muy alto" }
  ],
  "Liderazgo y relaciones en el trabajo": [
    { min: 0, max: 13, nivel: "Nulo" }, { min: 14, max: 28, nivel: "Bajo" },
    { min: 29, max: 41, nivel: "Medio" }, { min: 42, max: 57, nivel: "Alto" }, { min: 58, max: 999, nivel: "Muy alto" }
  ],
  "Entorno organizacional": [
    { min: 0, max: 9, nivel: "Nulo" }, { min: 10, max: 13, nivel: "Bajo" },
    { min: 14, max: 17, nivel: "Medio" }, { min: 18, max: 22, nivel: "Alto" }, { min: 23, max: 999, nivel: "Muy alto" }
  ],
};

export const NIVELES_DOMINIO_GIII = {
  "Condiciones en el ambiente de trabajo": [
    { min: 0, max: 4, nivel: "Nulo" }, { min: 5, max: 8, nivel: "Bajo" },
    { min: 9, max: 10, nivel: "Medio" }, { min: 11, max: 13, nivel: "Alto" }, { min: 14, max: 999, nivel: "Muy alto" }
  ],
  "Carga de trabajo": [
    { min: 0, max: 14, nivel: "Nulo" }, { min: 15, max: 20, nivel: "Bajo" },
    { min: 21, max: 26, nivel: "Medio" }, { min: 27, max: 36, nivel: "Alto" }, { min: 37, max: 999, nivel: "Muy alto" }
  ],
  "Falta de control sobre el trabajo": [
    { min: 0, max: 10, nivel: "Nulo" }, { min: 11, max: 15, nivel: "Bajo" },
    { min: 16, max: 20, nivel: "Medio" }, { min: 21, max: 24, nivel: "Alto" }, { min: 25, max: 999, nivel: "Muy alto" }
  ],
  "Jornada de trabajo": [
    { min: 0, max: 0, nivel: "Nulo" }, { min: 1, max: 1, nivel: "Bajo" },
    { min: 2, max: 3, nivel: "Medio" }, { min: 4, max: 5, nivel: "Alto" }, { min: 6, max: 999, nivel: "Muy alto" }
  ],
  "Interferencia en la relación trabajo-familia": [
    { min: 0, max: 3, nivel: "Nulo" }, { min: 4, max: 5, nivel: "Bajo" },
    { min: 6, max: 7, nivel: "Medio" }, { min: 8, max: 9, nivel: "Alto" }, { min: 10, max: 999, nivel: "Muy alto" }
  ],
  "Liderazgo": [
    { min: 0, max: 8, nivel: "Nulo" }, { min: 9, max: 11, nivel: "Bajo" },
    { min: 12, max: 15, nivel: "Medio" }, { min: 16, max: 19, nivel: "Alto" }, { min: 20, max: 999, nivel: "Muy alto" }
  ],
  "Relaciones en el trabajo": [
    { min: 0, max: 9, nivel: "Nulo" }, { min: 10, max: 12, nivel: "Bajo" },
    { min: 13, max: 16, nivel: "Medio" }, { min: 17, max: 20, nivel: "Alto" }, { min: 21, max: 999, nivel: "Muy alto" }
  ],
  "Violencia": [
    { min: 0, max: 6, nivel: "Nulo" }, { min: 7, max: 9, nivel: "Bajo" },
    { min: 10, max: 12, nivel: "Medio" }, { min: 13, max: 15, nivel: "Alto" }, { min: 16, max: 999, nivel: "Muy alto" }
  ],
  "Reconocimiento del desempeño": [
    { min: 0, max: 5, nivel: "Nulo" }, { min: 6, max: 9, nivel: "Bajo" },
    { min: 10, max: 13, nivel: "Medio" }, { min: 14, max: 17, nivel: "Alto" }, { min: 18, max: 999, nivel: "Muy alto" }
  ],
  "Insuficiente sentido de pertenencia e, inestabilidad": [
    { min: 0, max: 3, nivel: "Nulo" }, { min: 4, max: 5, nivel: "Bajo" },
    { min: 6, max: 7, nivel: "Medio" }, { min: 8, max: 9, nivel: "Alto" }, { min: 10, max: 999, nivel: "Muy alto" }
  ],
};
